import {Injectable} from "@angular/core";
import {Store} from "@ngxs/store";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {ToastController} from "@ionic/angular";
import { navigateFromNotificationAction } from '../core/utils/notification-routing.util';

@Injectable({
  providedIn: 'root',
})
export class LocalActivePushNotificationAdapter {
  constructor(
    private readonly _store: Store,
    private readonly _translate: TranslateService,
    private readonly _router: Router,
    private readonly _toastController: ToastController
  ) {
  }


  async showNotificationChat(notification: { title: string, body: string, id: string }) {
    const toast = await this._toastController.create({
      translucent: true,
      icon: 'chatbubbles',
      header: notification.title,
      message: (notification.body.length > 50 ? notification.body.substring(0, 50) + "..." : notification.body),
      color: 'primary',
      duration: 4000,
      position: 'top',
      buttons: [
        {
          text: this._translate.instant('GENERICS.LABELS.SEE'),
          role: "info",
          handler: () => {
            navigateFromNotificationAction(this._router, {
              action: 'routing_event',
              type: 'chat',
              id: notification.id,
            });
          }
        }
      ]
    });

    await toast.present();
  }
}
